import ProductCard from "./ProductCard";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface Product {
  id: string;
  name: string;
  price: number;
  sale_price?: number;
  originalPrice?: number;
  image?: string;
  images?: Array<{ url: string; position: number }>;
  category?: string;
  badge?: string;
  rating?: number;
}

interface ProductSectionProps {
  title: string;
  subtitle?: string;
  products: Product[];
  viewAllLink?: string;
  background?: "default" | "accent";
}

const ProductSection = ({
  title,
  subtitle,
  products,
  viewAllLink = "#",
  background = "default",
}: ProductSectionProps) => {
  const bgClass = background === "accent" ? "bg-muted/50" : "bg-background";

  return (
    <section className={`py-16 ${bgClass}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-8">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-2">{title}</h2>
            {subtitle && (
              <p className="text-muted-foreground text-lg">{subtitle}</p>
            )}
          </div>
          <Button variant="ghost" className="group mt-4 md:mt-0" asChild>
            <a href={viewAllLink}>
              View All
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </Button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <ProductCard key={product.id} {...product} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
